import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  Box1NegatieveUitgavenVoorInkomensvoorzieningen, IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box1-negatieve-uitgaven-voor-inkomensvoorzieningen',
  templateUrl: './box1-negatieve-uitgaven-voor-inkomensvoorzieningen.component.html',
  styleUrls: ['./box1-negatieve-uitgaven-voor-inkomensvoorzieningen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class Box1NegatieveUitgavenVoorInkomensvoorzieningenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;
    public year = 2024;

    public showSpinner = true;

    public negatievePremies = this.fb.group<Box1NegatieveUitgavenVoorInkomensvoorzieningen>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.negatievePremies = this.fb.group<Box1NegatieveUitgavenVoorInkomensvoorzieningen>({
            terugontvangenPremieAOV: null as unknown as number,
            terugontvangenPremieLijfrente: null as unknown as number,
        })
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm();
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.negatievePremies.reset()
                    this.updateForm();
                });
                if (incomeTaxEntity.year !== undefined) {
                    this.year = incomeTaxEntity.year;
                }
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {this.handleUrlChange(event.urlAfterRedirects);});
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.negatievePremies.dirty
    }

    private updateForm() {
        this.partner.subscribe((partner) => {
            if (!partner) {
                this.negatievePremies.patchValue(this.aangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen || null as unknown as Box1NegatieveUitgavenVoorInkomensvoorzieningen,);
            } else {
                this.negatievePremies.patchValue(this.aangifte?.partnerAangifte?.box1?.negatieveUitgavenVoorInkomensvoorzieningen || null as unknown as Box1NegatieveUitgavenVoorInkomensvoorzieningen,);
            }
        })
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    negatieveUitgavenVoorInkomensvoorzieningen: this.negatievePremies.value
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        negatieveUitgavenVoorInkomensvoorzieningen: this.negatievePremies.value
                    }
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.negatievePremies.markAsDirty()
        }
    }
}
